import AlbumPhotoMenu from './AlbumPhotoMenu';

export default AlbumPhotoMenu;
